import { z } from "zod";
import { Rollup, Resolution } from "./environmental";

export enum EnvironmentalType {
  energy = "energy",
  water = "water",
  waste = "waste",
}

export type IEnvironmentalParametersSchema = z.infer<typeof TEnvironmentalParametersSchema>;
export const TEnvironmentalParametersSchema = z.object({
  from: z.string().date(),
  to: z.string().date(),
  companyID: z.string().optional(),
  rollup: z.nativeEnum(Rollup).optional(),
  resolution: z.nativeEnum(Resolution).optional(),
  environmentalType: z.nativeEnum(EnvironmentalType).optional(),
});
